import { IsoDate } from "helpers/types/dates"
import useResource from "hooks/resources"

interface Dataset {
  id: string
  name: string
  type: string
  description: string
  publisher: string
  region: string
  updatedAt: IsoDate
}

const DATASETS_QUERY = `query {
  datasets {
    id
    name
    type
    description
    publisher
    region
    updatedAt
  }
}`

export function useDatasets() {
  return useResource<Dataset[] | null>({
    resource: "datasets",
    url: () => {
      return {
        id: "datasets",
        query: DATASETS_QUERY,
      }
    },
  }, ["datasets"])
}
